import React from 'react';
import { Users, Calendar } from 'lucide-react';
import { Button } from '../ui/button';
import { formatDate, getStatusColor } from './diningConstants';

export function ReservationsSection({ reservations, onManageReservation }) {
    return (
        <div className="space-y-6" data-testid="reservations-section">
            <div>
                <h2 className="text-2xl font-bold">Dining Reservations</h2>
                <p className="text-muted-foreground">{reservations.length} reservations</p>
            </div>
            
            {reservations.length === 0 ? (
                <div className="bg-stone-100 rounded-xl p-12 text-center">
                    <Users className="w-12 h-12 text-stone-300 mx-auto mb-3" />
                    <p className="text-stone-500">No reservations yet</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {reservations.map(res => (
                        <div key={res.id} className="bg-white rounded-xl p-4 border border-stone-200" data-testid={`reservation-${res.id}`}>
                            <div className="flex items-start justify-between">
                                <div className="flex-1">
                                    <div className="flex items-center gap-3 mb-2">
                                        <span className="font-semibold">{formatDate(res.date)} at {res.time}</span>
                                        <span className={`text-xs px-2 py-1 rounded-full capitalize ${getStatusColor(res.status, 'reservation')}`}>
                                            {res.status}
                                        </span>
                                    </div>
                                    <p className="text-sm text-stone-600">
                                        Party of {res.party_size}
                                        {res.table_number && <span className="ml-2">• Table {res.table_number}</span>}
                                    </p>
                                    {res.special_requests && (
                                        <p className="text-sm text-stone-500 mt-1 italic">"{res.special_requests}"</p>
                                    )}
                                    <p className="text-xs text-stone-400 mt-2">
                                        Resident: {res.user?.email || res.user_email || 'Unknown'}
                                    </p>
                                </div>
                                <Button variant="outline" size="sm" onClick={() => onManageReservation(res)} data-testid={`manage-reservation-${res.id}`}>
                                    Manage
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ReservationsSection;
